export const FB_PIXEL_ID = '1894952884093651';
export const FB_URL = 'https://www.facebook.com/tr';
export const FB_DEFAULT_QUERY = {
  id: FB_PIXEL_ID,
  zscript: 1,
  dl: 'https://hotpads.com',
};
